module.exports = "https://static.wanderu.com/static/media/nl.f5d20958.svg";